import {GameFont} from '../../GameFont'
import {UIGameBaseAchievementView} from './UIGameBaseAchievementView'
import {UIGameManager} from '../UIGameManager'
import {InGameAchievement} from './UIGameAchievementController'

export class UIGameFirstTimeClaimedAchievementView extends UIGameBaseAchievementView {
    constructor(options: InGameAchievement, uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, avatarSize: number) {
        super(options, uiGameManager, x, y, w, h, avatarSize)
        this.titleSection.createTitle()
        this.titleSection.createAchievementScore()
        this.titleSection.createAchievementIcon()

        const playerNameRightEnd = this.descriptionSection.width * 0.65
        const currentOwnerAvatar = this.descriptionSection.createAvatar(this.margin, this.achievementOptions.achievementOwnerNew)
        const currentOwnerName = this.descriptionSection.createPlayerName(playerNameRightEnd, currentOwnerAvatar, GameFont.Size.Normal, this.achievementOptions.achievementOwnerNew)
        this.descriptionSection.createVPChangeView(currentOwnerName, true, true)
        this.drawBackground()
    }
}
